/**
 * created by xcc on 2022/3/14
 * 媒体管理批量新增组件
 */
import React from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    Icon,
    Table,
    Input,
    Select,
    Button,
    Menu,
    Upload,
    Dropdown, Popconfirm, InputNumber
} from "antd";
import Scrollbars from "react-custom-scrollbars";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import ButtonGroup from "antd/es/button/button-group";
import {uuid} from "../../../utils";
import BaseComponent from "../../../base/BaseComponent";
import SelectModal from "./SelectModal";
import ScrollBars from "react-custom-scrollbars";
import {Prompt} from "react-router-dom";
import {
    confirmAdd,
    downLoadTemplate,
    getDeptData,
    getMediaSortData,
    getMediaTypeList
} from "../actions/mediaAdminister";
import DeptTree from "./DeptTree";

const {Option} = Select;

const requiredMark = () => {
    return <span style={{color: "red", marginRight: 3}}>*</span>
};
export default class MediaAdministerBatchAdd extends BaseComponent {
    static defaultProps = {}
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            dataSourceHold: [],//暂存数据
            prohibitExit: false,
            visible: false,
            modalTitle: "",
            deptName: "",
            deptId: undefined,
            userIds: [],
            //批量选择部门
            deptVisible: false,
            mediaPlatformNoAll: [],
            departAllList: [],
            currEditId: "",
            currEditManagerId: "",
        };
        this.batchAddColumns = [
            {
                title: <>{requiredMark()}媒体名称</>,
                dataIndex: "name",
                key: "name",
                ellipsis: true,
                width: 150,
                render: (text, record) => {
                    return (
                        <Input
                            placeholder={"请输入"}
                            value={record.name}
                            onChange={(e) => {
                                record.name = e.target.value.trim();
                                this.setState({});
                            }}
                        />
                    );
                }
            },
            {
                title: <>{requiredMark()}媒体类型</>,
                key: "mediaTypeCode",
                dataIndex: "mediaTypeCode",
                width: 90,
                ellipsis: true,
                render: (text, record) => {
                    return (
                        <Select placeholder={"请选择"}
                                value={record.mediaTypeCode || undefined}
                                style={{width: '100%', backgroundColor: "#fff"}}
                                onChange={(e) => {
                                    record.mediaTypeCode = e;
                                    this.setState({})
                                }}>
                            {this.state.mediaPlatformNoAll.map((item, i) => {
                                return (
                                    <Option key={i} value={item.mediaTypeCode}>{item.mediaTypeName}</Option>
                                )
                            })}
                        </Select>);
                }
            },
            {
                title: <>{requiredMark()}融媒号类型</>,
                key: "rmType",
                dataIndex: "rmType",
                width: 80,
                ellipsis: true,
                render: (text, record) => {
                    return (
                        record.mediaTypeCode === "rmapp" ?
                            <Select placeholder={"请选择"}
                                    value={(record.rmType === 1 || record.rmType === 0) ? record.rmType : undefined}
                                    style={{width: '100%', backgroundColor: "#fff"}}
                                    onChange={(e) => {
                                        record.rmType = e;
                                        this.setState({})
                                    }}>
                                <Option key={"dept"} value={0}>机构号</Option>
                                <Option key={"person"} value={1}>达人号</Option>
                            </Select> : null
                    );
                }
            },
            {
                title: <>{requiredMark()}所属部门</>,
                ellipsis: true,
                key: 'deptName',
                dataIndex: "deptName",
                width: 110,
                render: (text, record) => {
                    return (
                        <div style={{cursor: "pointer"}} onClick={() => {
                            this.openDeptModal(record)
                        }}>
                            <Input placeholder={"请选择"}
                                   value={record.deptName}
                                   style={{width: '100%', cursor: "pointer"}}
                                   readOnly={true}
                            />
                        </div>
                    )
                }
            },
            {
                title: '媒体描述',
                dataIndex: "description",
                key: "description",
                ellipsis: true,
                width: 130,
                render: (text, record) => {
                    return (
                        <Input
                            placeholder={"请输入"}
                            value={record.description}
                            onChange={(e) => {
                                record.description = e.target.value.trim();
                                this.setState({});
                            }}
                        />
                    );
                }
            },
            {
                title: '媒体LOGO',
                key: 'mediaLogo',
                dataIndex: "mediaLogo",
                width: 60,
                render: (text, record) => {
                    const uploadButton = (
                        <div key={uuid()}>
                            <Icon type={'plus'}/>
                        </div>
                    );
                    return (
                        <div id={"mediaAdministerBatchUpload"}>
                            <div style={{position: "relative", width: 40, height: 40, margin: "auto"}}>
                                <Upload
                                    name="file"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    beforeUpload={beforeUpload}
                                    customRequest={({file}) => {
                                        let url = "/storage/uploadFile";
                                        let fd = new FormData();
                                        fd.append("file", file);
                                        this.request({
                                            url,
                                            body: fd,
                                            method: "post",
                                            contentType: "upload",
                                            callBack: (file) => {
                                                let that = this;
                                                if (file) {
                                                    record.mediaLogo = file.path ? file.path : null;
                                                    that.setState({})
                                                }
                                            },
                                            errorCallBack: () => {

                                            },
                                            serverVerify: {
                                                serverErrorCallBack: () => {

                                                }
                                            }
                                        });
                                    }}
                                >
                                    {record.mediaLogo ?
                                        <div>
                                            <img src={record.mediaLogo} alt="avatar" style={{
                                                width: '32px',
                                                height: '32px',
                                                objectFit: 'cover',
                                                borderRadius: "50%"
                                            }}/>
                                        </div> : uploadButton}
                                </Upload>
                                <Icon onClick={() => {
                                    record.mediaLogo = "";
                                    this.setState({});
                                }} style={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                    fontSize: "16px",
                                    color: "red",
                                    display: record.mediaLogo ? "block" : "none"
                                }}
                                      type="close-circle" theme="filled"/>
                                <style>{`
                                            #mediaAdministerBatchUpload .ant-upload.ant-upload-select-picture-card{width:40px;height:40px;background:#FFF;margin-right: 0;margin-bottom: 0;}
                                            #mediaAdministerBatchUpload .ant-upload-picture-card-wrapper{display: flex;align-items: center;justify-content: center;}
                                            #mediaAdministerBatchUpload .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                                       `}</style>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: "媒体管理员",
                key: 'accountNames',
                dataIndex: "accountNames",
                width: 130,
                render: (text, record) => {
                    return (
                        <div style={{cursor: "pointer"}} onClick={() => {
                            this.openManagerModal(record)
                        }}>
                            <Input
                                placeholder={"请选择"}
                                value={(record.accountNames && record.accountNames.length && record.accountNames.join("，")) || ""}
                                style={{width: '100%', cursor: "pointer"}}
                                readOnly={true}
                            />
                        </div>
                    )
                }
            },
            {
                title: <>{requiredMark()}媒体排序</>,
                dataIndex: "sort",
                key: "sort",
                ellipsis: true,
                width: 80,
                render: (text, record) => {
                    return (
                        <InputNumber
                            placeholder={"请输入"}
                            value={record.sort}
                            min={0}
                            onChange={(sort) => {
                                record.sort = sort;
                                this.setState({});
                            }}
                        />
                    );
                }
            },
            {
                title: '操作',
                ellipsis: true,
                key: 'operate',
                width: 100,
                render: (text, record) => {
                    let title = "确定移除这行数据？";
                    return (
                        <div className="operate_btns">
                            <Popconfirm
                                icon={<Icon type="question-circle-o" style={{color: 'red'}}/>}
                                title={title}
                                onConfirm={() => this.delCell(record.id)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <span className="del">移除</span>
                            </Popconfirm>
                        </div>
                    );
                }
            },
        ];

    }

    componentWillMount() {

    }

    componentDidMount() {
        //所属部门
        this.getDept();
        //媒体类型
        this.getMediaType();
    }

    /**
     * 媒体类型
     **/
    getMediaType() {
        getMediaTypeList({}, (data) => {
            let mediaPlatformNoAll = [];
            if (data && data.length > 0) {
                mediaPlatformNoAll = data;
            }
            this.setState({
                mediaPlatformNoAll
            });
        });
    }

    /**
     * 所属部门
     **/
    getDept() {
        let params = {
            id: "0"
        };
        getDeptData(params, (data) => {
            if (data) {
                let departAllList = [
                    {
                        name: data.name,
                        id: data.id,
                        sons: data.child,
                    },
                ];
                this.setState({
                    departAllList
                });
            }
        });
    }

    checkedNode(checkedNodeKey, checkedNodeName) {
        let deptId = checkedNodeKey[0];
        let deptName = checkedNodeName;
        let tempSort= 0 ;
        let checkedData = {
            deptId: deptId,
            deptName: deptName,
        }
        this.state.dataSourceHold.forEach((item, index) => {
            if (item.id === this.state.currEditId) {
                if (deptId !== item.deptId) {
                    this.state.dataSourceHold[index].sort = "";
                    this.state.dataSourceHold[index].userIds = [];
                    this.state.dataSourceHold[index].accountNames = [];
                }
                this.state.dataSourceHold[index] = {...item, ...checkedData}
            }
            if(item.id !== this.state.currEditId && deptId === item.deptId){
                if(item.sort > tempSort){
                    tempSort = item.sort;
                }
            }
        })
        this.setState({deptVisible: false, deptId, deptName}, () => {
            this.sortVerify(deptId, this.state.currEditId, tempSort);
        })
    }

    sortVerify(deptId, currEditId, tempSort) {
        let params = {
            deptId: deptId
        };
        getMediaSortData(params, (data) => {
            let dataSourceHoldItem = this.state.dataSourceHold.find(item => item.id === currEditId);
            dataSourceHoldItem.sort = data + 1;
            if(tempSort){
                dataSourceHoldItem.sort = tempSort + 1;
            }
            this.setState({})
        })
    }

    //删除行
    delCell = (id) => {
        // 删除行 删除暂存和编辑里面的行
        let {dataSourceHold} = this.state;
        this.setState({
            dataSourceHold: dataSourceHold.filter(item => item.id !== id),
            prohibitExit: true
        });
    };

    openDeptModal(currentEdit) {
        currentEdit = {...this.state.dataSourceHold.find(item => item.id === currentEdit.id)};
        if (!currentEdit.deptId) {
            this.state.deptId = "";
            this.state.deptName = "";
        } else {
            this.state.deptId = currentEdit.deptId;
            this.state.deptName = currentEdit.deptName;
        }
        this.deptTree.loadKey();
        this.setState({
            deptVisible: true,
            currEditId: currentEdit.id,
        })
    }

    openManagerModal(currentEdit) {
        currentEdit = {...this.state.dataSourceHold.find(item => item.id === currentEdit.id)};
        if (!currentEdit.deptId) {
            message.warn("请先选择所属部门！");
            return;
        }
        this.mediaAdministerBatchAdd.state.deptUserList = [];  //清空数据防止因数据存在而选中闪现
        this.setState({
            visible: true,
            modalTitle: "选择管理员",
            currEditManagerId: currentEdit.id,
        }, () => {
            this.mediaAdministerBatchAdd.state.page = 1;
            let userData = []
            if(currentEdit.userIds && currentEdit.userIds.length){
                userData = JSON.parse(JSON.stringify(currentEdit.userData))
            }
            this.mediaAdministerBatchAdd.getDeptUser(currentEdit, userData);
        })
    }

    //批量新增添加
    batchNewAdd() {
        const id = uuid();
        const defaultLine = {
            id: id,
            name: "", //媒体名称
            mediaTypeCode: "", //媒体类型
            deptId: "", //所属部门id
            deptName: "", //所属部门名称
            description: "", //媒体描述
            mediaLogo: "", //媒体logo
            userIds: [], //媒体管理员
            accountNames: [], //媒体管理员名称
            sort: "",  //媒体排序
            rmType: 0, //融媒号类型
        };
        this.state.dataSourceHold.push((JSON.parse(JSON.stringify(defaultLine))));
        this.setState({
            prohibitExit: true
        });
    }

    getBatchSort(item, callback) {
        let params = {
            deptId: item.deptId
        };
        getMediaSortData(params, (data) => {
            callback(data + 1);
        })
    }

    render() {
        const menu = <Menu id={"mediaAdministerMenu"}>
            <Menu.Item>
                <Upload accept={".xlsx,.xls"}
                        showUploadList={false}
                        customRequest={({file}) => {
                            let url = "/cm-sites-pms/media/batchSaveMediaWithTemplate";
                            let fd = new FormData();
                            fd.append("file", file);
                            this.request({
                                url, callBack: (data) => {
                                    let that = this;
                                    if (data && data.length) {
                                        message.success("批量导入成功！");
                                        let num = 0;
                                        data.forEach((item, index) => {
                                            data[index].id = uuid();
                                            data[index].accountNames = data[index].userNames;
                                            data[index].deptName = [data[index].deptName];
                                            this.getBatchSort(data[index], (sort) => {
                                                data[index].sort = sort;
                                                num++;
                                                if (num == data.length) {
                                                    that.state.dataSourceHold = [...that.state.dataSourceHold, ...data];
                                                    that.setState({
                                                        prohibitExit: true
                                                    })
                                                }
                                            })
                                        })

                                    } else {
                                        message.error("批量导入失败！");
                                    }
                                }, contentType: "upload", method: "post", body: fd,
                                errorCallBack: () => {
                                }, serverVerify: {
                                    serverErrorCallBack: () => {

                                    }
                                }
                            });
                        }}
                >
                    批量导入
                </Upload>
            </Menu.Item>
            <style>{`
            #mediaAdministerMenu .ant-dropdown-menu-item{padding: 5px 0px;}
            #mediaAdministerMenu .ant-upload.ant-upload-select>span{display: inline-block;width: 100px;padding-left: 10px;}
            `}</style>
            <Menu.Item onClick={() => {
                this.getTemplate()
            }}><span style={{paddingLeft: 10}}>下载模板</span></Menu.Item>
        </Menu>
        let height = window.innerHeight - 390;
        return (
            <div style={{backgroundColor: "#fff"}}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: '20px'
                }} id={"mediaAdministerDropdownBtn"}>
                    <div style={{paddingBottom: "10px", paddingLeft: "32px"}}>
                        <Dropdown overlay={menu} placement="bottomLeft">
                            <ButtonGroup>
                                <Button type={"primary"}>批量导入</Button>
                                <Button type={"primary"} icon="ellipsis"/>
                            </ButtonGroup>
                        </Dropdown>
                    </div>
                    <style>{`#mediaAdministerDropdownBtn .ant-btn.ant-btn-primary.ant-btn-icon-only{padding: 0px 10px 0px 0px;}
                    #mediaAdministerDropdownBtn .ant-btn.ant-btn-primary{padding: 0px 0px 0px 10px;}
                    `}</style>
                </div>
                <div style={{padding: "20px 32px 0px 32px"}} id={"mediaAdministerBatchTable"}>
                    <Scrollbars autoHeight autoHeightMax={height}>
                        <Table
                            columns={this.batchAddColumns}
                            pagination={false}
                            dataSource={this.state.dataSourceHold}
                            bordered={true}
                        />
                    </Scrollbars>
                    <style>{`
                        #mediaAdministerBatchTable table {border: 0px !important}
                        #mediaAdministerBatchTable table th {
                            border: 0px !important;
                            background: rgba(0, 80, 179, 0.04) !important;
                        }
                        #mediaAdministerBatchTable table td {border: 0px !important}
                        #mediaAdministerBatchTable table tr:nth-child(even){
                            background: rgba(0, 80, 179, 0.04) !important;
                        }
                        #mediaAdministerBatchTable .ant-table-placeholder {border: 0px !important}
                        #mediaAdministerBatchTable .ant-table-tbody > tr > td {padding: 8px 16px;}
                    `}</style>
                    {/*渲染添加按钮*/}
                    <div onClick={() => {
                        this.batchNewAdd()
                    }} style={{
                        cursor: "pointer",
                        textAlign: "center",
                        width: "100%",
                        height: "40px",
                        lineHeight: "40px",
                        border: "1px dashed #D9D9D9",
                        margin: "10px 0px"
                    }}>
                        <Icon type="plus" style={{marginRight: "5px"}}/>添加
                    </div>
                    <style>{`
                    #mediaAdministerBatchTable .ant-table-bordered .ant-table-body > table{border: 1px solid #e8e8e8;}
                `}</style>
                </div>
                {/*渲染底部按钮*/}
                {this.renderBottomBtn()}
                {/*选择管理员*/}
                <SelectModal
                    visible={this.state.visible}
                    modalTitle={this.state.modalTitle}
                    onRef={(c) => this.mediaAdministerBatchAdd = c}
                    onCancel={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                    onOk={(userData) => {
                        let accountNames = [];
                        let userIds = [];
                        userData.forEach(item => {
                            if (item.checked) {
                                accountNames.push(item.name);
                                userIds.push(item.id);
                            }
                        })
                        let checkedData = {
                            userIds: userIds,
                            accountNames: accountNames,
                            userData: userData
                        }
                        this.state.dataSourceHold.forEach((item, index) => {
                            if (item.id === this.state.currEditManagerId) {
                                this.state.dataSourceHold[index] = {...item, ...checkedData}
                            }
                        })
                        this.setState({
                            visible: false
                        })
                    }}
                />
                {/*部门选择*/}
                <DeptTree
                    deptVisible={this.state.deptVisible}
                    departAllList={this.state.departAllList}
                    checkedNodeKey={[this.state.deptId]}
                    checkedNodeName={this.state.deptName}
                    onCancelChecked={() => {
                        this.setState({
                            deptVisible: false
                        })
                    }}
                    onOkCheck={(checkedNodeKey, checkedNodeName) => {
                        this.checkedNode(checkedNodeKey, checkedNodeName);
                    }}
                    showSearch={true}
                    ref={(c) => this.deptTree = c}
                />
            </div>
        )
    }

    //渲染底部按钮
    renderBottomBtn() {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                borderTop: "1px solid #e3e0e0",
                alignItems: "center",
                paddingTop: 15,
                marginTop: 40
            }}>
                <div style={{marginRight: "10px"}}>
                    <Button onClick={() => {
                        this.exit()
                    }}>返回</Button>
                </div>
                <div>
                    <Button type={"primary"} onClick={() => {
                        this.okAdd()
                    }}>确定新增</Button>
                </div>
            </div>
        )
    }

    okAdd() {
        let {dataSourceHold,} = this.state;
        let flag = false;
        if (!dataSourceHold.length) {
            message.warn("请先添加数据！");
            return false;
        }
        dataSourceHold.forEach((item) => {
            if (!item.name || !item.mediaTypeCode || !item.deptId || (!item.sort && item.sort !== 0) || (item.mediaTypeCode && item.mediaTypeCode === "rmapp" && !item.rmType && item.rmType !== 0)) {
                flag = true;
            }
        })
        if (flag) {
            message.warn("请检查必填项！");
            return;
        }
        dataSourceHold.forEach((item, index) => {
            dataSourceHold[index].id = null;
            dataSourceHold[index].deptName = item.deptName[0];
            //融媒机构号和达人号默认图片
            if(!item.mediaLogo && item.mediaTypeCode === "rmapp") {
                if(item.rmType === 0){
                    item.mediaLogo = "images/rm/defaultType1.png";
                }else{
                    item.mediaLogo = "images/rm/defaultType2.png";
                }
            }
        })
        let body = {
            mediaDtoList: dataSourceHold,
        };
        confirmAdd(body, (data, status) => {
            if (status === 200) {
                message.success("确定新增成功！");
                this.revertData();
            }
        }, {
            info: (info) => {
                message.error(info);
            }
        })
    }

    exit() {
        if (this.state.prohibitExit && this.state.dataSourceHold.length) {
            Modal.confirm({
                title: '确认是否强制退出？',
                content: <div>
                    <div>检测到当前有操作没有保存，退出后当前修改数据将会丢失</div>
                </div>,
                centered: 'centered',
                okText: "确定",
                okCancel: "取消",
                onOk: () => {
                    this.revertData();
                    this.props.goBack();
                }
            })
        } else {
            this.revertData();
            this.props.goBack();
        }
    }

    revertData() {
        this.setState({
            dataSourceHold: [],//暂存数据
            prohibitExit: false,
        })
    }

    //获取导入模板
    getTemplate() {
        window.loading.show();
        downLoadTemplate({}, (data) => {
            window.loading.hide();
        })
    }
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('只能上传JPG、PNG文件！');
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error('图片大小必须小于20MB！');
    }
    return isJpgOrPng && isLt2M;
}
